import { render, staticRenderFns } from "./ConfirmMessageTab.vue?vue&type=template&id=e8180564&scoped=true"
import script from "./ConfirmMessageTab.vue?vue&type=script&lang=js"
export * from "./ConfirmMessageTab.vue?vue&type=script&lang=js"
import style0 from "./ConfirmMessageTab.vue?vue&type=style&index=0&id=e8180564&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8180564",
  null
  
)

export default component.exports